import React from "react";
import { DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown } from "reactstrap";
import { Icon } from "../../../Component";
import { LineChart } from "../../charts/default/Charts";
import exportFromJSON from "export-from-json";

const formatDate = (dateString) => {
  const d = new Date(dateString);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const SalesOverview = ({ totalRevenue, totalOrders, lineChartData, orders = [], filterLabel = "Last 30 Days" }) => {

  // ── Download Helpers ─────────────────────────────────────────────────────
  const buildReportData = () =>
    orders.map((o) => ({
      "Order Ref":        o.order_ref,
      "Customer Name":    o.customer?.name || "",
      "Customer Phone":   o.customer?.phone || "",
      "Customer Email":   o.customer?.email || "",
      "Customer Address": o.customer?.address || "",
      "Order Status":     o.order_status,
      "Payment Method":   o.payment_method === "cod" ? "Cash on Delivery" : "Online",
      "Payment Status":   o.payment_status,
      "Total (₹)":        o.total,
      "Order Date":       formatDate(o.created_at),
    }));

  const handleDownload = (type) => {
    const data     = buildReportData();
    const fileName = `ryzhm_orders_report_${new Date().toISOString().slice(0, 10)}`;
    exportFromJSON({ data, fileName, exportType: type });
  };

  return (
    <React.Fragment>
      <div className="card-title-group align-start gx-3 mb-3">
        <div className="card-title">
          <h6 className="title">Sales Overview</h6>
          <p>
            {filterLabel} sales from orders.{" "}
            <a href="#details" onClick={(ev) => ev.preventDefault()}>
              See Details
            </a>
          </p>
        </div>
        <div className="card-tools">
          <UncontrolledDropdown>
            <DropdownToggle tag="div" color="transparent">
              <a
                href="#toggle"
                onClick={(ev) => ev.preventDefault()}
                className="btn btn-primary btn-dim d-none d-sm-inline-flex"
              >
                <Icon className="d-none d-sm-inline" name="download-cloud" />
                <span>
                  <span className="d-none d-md-inline">Download</span> Report
                </span>
              </a>
              <a
                href="#toggle"
                onClick={(ev) => ev.preventDefault()}
                className="btn btn-primary btn-icon btn-dim d-sm-none"
              >
                <Icon name="download-cloud" />
              </a>
            </DropdownToggle>
            <DropdownMenu end>
              <ul className="link-list-opt no-bdr">
                <li>
                  <DropdownItem
                    tag="a"
                    href="#csv"
                    onClick={(ev) => {
                      ev.preventDefault();
                      handleDownload("csv");
                    }}
                  >
                    <Icon name="file-text" />
                    <span>Download CSV</span>
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    tag="a"
                    href="#xls"
                    onClick={(ev) => {
                      ev.preventDefault();
                      handleDownload("xls");
                    }}
                  >
                    <Icon name="file-xls" />
                    <span>Download Excel</span>
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    tag="a"
                    href="#json"
                    onClick={(ev) => {
                      ev.preventDefault();
                      handleDownload("json");
                    }}
                  >
                    <Icon name="code" />
                    <span>Download JSON</span>
                  </DropdownItem>
                </li>
              </ul>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
      <div className="nk-sale-data-group align-center justify-between gy-3 gx-5">
        <div className="nk-sale-data">
          <span className="amount">
            {totalRevenue !== undefined
              ? `₹ ${Number(totalRevenue).toLocaleString("en-IN")}`
              : "Loading..."}
          </span>
        </div>
        <div className="nk-sale-data">
          <span className="amount sm">
            {totalOrders !== undefined ? totalOrders : "--"}{" "}
            <small>Orders</small>
          </span>
        </div>
      </div>
      <div className="nk-sales-ck large pt-4">
        <LineChart chartData={lineChartData} />
      </div>
    </React.Fragment>
  );
};
export default SalesOverview;
